/* tslint:disable */
/* eslint-disable */

/**
 * 0 = SocialHousing
 * 
 * 1 = Retail
 */
export enum Department {
  SocialHousing = 0,
  Retail = 1
}
